import '..//..//..//mixins.js'
import axios from 'axios';
import {mapGetters, mapActions} from 'vuex'
//import Plotly from 'plotly.js-basic-dist-min'
var Plotly = require('./../../../custom_bundles/custom-plotly.js');
import Tabs from "../../general/Tabs/Tabs.vue"
import Tab from "../../general/Tab/Tab.vue"
import Vue from 'vue'
import spinner from "../../LoadingComponent/LoadingComponent.vue"
import slider from "../../SliderComponent/SliderComponent.vue"

// npm install --save-dev @fortawesome/fontawesome-free
var domain = "https://user.sigmafolio.net/"
class Recommendation {
  constructor(isin, name, sector, security_type, region, security_price, model_result) {
    this.isin = isin;
    this.name = name;
    this.sector = sector;
    this.security_type = security_type;
    this.region = region;
    this.security_price = security_price;
    this.model_result = model_result;
  }
}


export default {
  name: 'portfolio',
  components: {
    Tab,
    Tabs,
    spinner,
    slider

  },
  props: [],
  data () {
    return {
      portfolio: [],
      dividends: [],
      sliderData: {
        stock: {
          bin: 50,
          value: 100,
          name: "Portfolio"
        },
        benchmark: {
          bin: 4,
          value: 8,
          name: "DAX"
        }
      },
      showButtonSpinner: false,
      showButtonSpinnerNew: false,
      assetDividends: [],
      assetDividendSum: 0,
      recommendations: [],
      isWatchlistModalOpen: false,
      isEndpointError: false,
      isVolaCalculated: false,
      tradeFromAssetMask: false,
      active: 1,
      slides: 5,
      isWatchlistColumnVisible: false,
      isPortfolioEmpty: false,
      stockid: 2,
      kpis: [],
      kpiKeys: {
        kennzahlen: [
          {"name": "Market Cap.","key": "market_capitalization"},
          {"name": "Mitarbeiter","key": "full_time_employees"},
          {"name": "KGV","key": "pe_ratio"},
          {"name": "KUV","key": "price_sales_ttm"},
          {"name": "EV","key": "enterprise_value"},
          {"name": "Div.-Rendite","key": "dividend_yield"}
        ]
      },
      isModalDeleteVisible: false,
      isModalVisible: false,
      isBuyOrSellModalVisible: false,
      isSecurityModalVisible: false,
      isSparplanModalVisible: false,
      sparplanModal: {
        add: false,
        overview: false,
      },
      sparplan: [],
      isModalDelete: false,
      isTradeSubSuccessful: false,
      isTradeDelSuccessful: false,
      isTradeEditSuccessful: false,
      isDividendSubSuccessful: false,
      isDividendDelSuccessful: false,
      isSparplanSubSuccessful: false,
      isSparplanDelSuccessful: false,
      isLoaded: false,
      isDividendModalOpen: false,
      isWatchlistEmpty: false,
      isWatchlistDataComplete: false,
      ipVolaTrend: 0,
      dateToday: new Date().toISOString().split('T')[0],
      totalPortfolio: {
        latest_value: 0,
        total_purchase_value: 0,
        return: 0
      },
      stockRecommendation: {
        name: "",
        isin: "",
        price: "",
        amount: "",
        totalValue: ""
      },
      isAssetModalVisible: false,
      assetModalIndex: 0,
      isInputValid: {
        type: true,
        name: true,
        isin: true,
        amount: true,
        sellAmount: true,
        tradeDate: true,
        tradeDateMin: true,
        purchasePrice: true,
        nameIsinMatches: true,
      },
      isDividendInputValid: {
        name: true,
        isin: true,
        name_isin_matches: true,
        trade_date: true,
        total_amount: true,
        total_tax_amount: true,
      },
      isEditInputValid: {
        type: true,
        //name: false,
        //isin: false,
        amount: true,
        tradeDate: true,
        purchasePrice: true
      },
      modalInput: [],
      newWeights: null,
      isInvestmentplanerOpen: {
        isRandomOpen: false,
        isChoiceOpen: false,
        isClicked: false,
      },
      input: {
        type: "",
        id: 0,
        name: "",
        isin: "",
        tradeDate: new Date().toISOString().split('T')[0],
        amount: 0,
        purchaseValue: 0,
        purchasePrice: 0,
        modelAssessment: "",
        tradeAmount: 0,
        currentPrice: 0,
        total_tax_amount: 0,
        interval: 'month',
        sparplan_amount: 0
        },
      editInput: [],
      addOrSellInput: [],
      showResultsName: false,
      showResultsIsin: false,
      showMoreResults: false,
      showSpinner: false,
      showSpinnerModal: false,
      priceSeries: null,
      portfolio_id : this.$route.params.PORTFOLIO_ID,
      currentVola : null,
      simulatedVola : null,
      showPerformanceDetails: false,
      startTime: new Date().toLocaleString().replace(',',''),
      searchResults: {},
      news: []
    }
  },
  computed: {
    ...mapGetters([/*'get_SC_searchData', */'get_PD_userData']),
    calcStockRecommendation: function(){
      if(this.isInvestmentplanerOpen.isRandomOpen){
        this.stockRecommendation.totalValue = parseFloat(this.stockRecommendation.amount.replace(",", ".")) * this.recommendations[this.active-1].security_price
      }else{
      this.stockRecommendation.totalValue = parseFloat(this.stockRecommendation.amount.replace(",", ".")) * this.stockRecommendation.price//this.recommendations[this.active-1].url
      }
      if(isNaN(this.stockRecommendation.totalValue)){
        return 0
      }
      return this.stockRecommendation.totalValue
    },
    calcAbsoluteProfitLoss: function(){
      //return Math.round((this.totalPortfolio.latest_value - this.totalPortfolio.total_purchase_value)*100)/100;
      var realizedProfit = 0
      try{
        this.portfolio.forEach(asset => {
          realizedProfit += asset.realized_profit
        })
        return realizedProfit
      }catch{
        return 0
      }

    },
    returnIRR: function(){
      try{
        let irr = this.get_PD_userData['portfolio_return']
        if (isNaN(irr)){
          return 0
        }
        return irr
      }catch{
        return 0
      }
    },
    returnDividends: function(){
      try{
        let dividends = this.get_PD_userData['total_net_dividends']
        if (isNaN(dividends)){
          return 0
        }
        return dividends
      }catch{
        return 0
      }
    },
    returnPLUnrealized: function(){
      var realizedProfit = 0
      try{
        this.portfolio.forEach(asset => {
          realizedProfit += asset.realized_profit
        })
        let profitUnrealized = this.get_PD_userData['portfolio_profit'] - realizedProfit
        
        
        if (isNaN(profitUnrealized)){
          return 0
        }
        return profitUnrealized
      }catch{
        return 0
      }
    },
    calcTotalProfitLoss: function(){
      try{
        let totalPL = this.get_PD_userData['portfolio_profit'] + this.get_PD_userData['total_net_dividends']
        if (isNaN(totalPL)){
          return 0
        }
        return (this.get_PD_userData['portfolio_profit'] + this.get_PD_userData['total_net_dividends'])
      }catch{
        return 0
      }
      
    },
    currentRoute() {
      return this.$router.currentRoute.name;
    },
    calcTradeAmount: function(){
      if(this.input.type === "sell"){
        return this.input.tradeAmount = - parseInt(this.input.amount)
      }else {
        return this.input.tradeAmount = parseInt(this.input.amount)
      }
    },
    filteredListName() {
        if(this.input.type == 'sell' || this.isDividendModalOpen == true){
          return this.portfolio.filter(security => {
            return security.name.toLowerCase().includes(this.input.name.toLowerCase()) || security.isin.toLowerCase().includes(this.input.name.toLowerCase())

          })  
        }else{
          return {name: "Keine Ergebnisse", isin:""}
        }
    
    },
    calcTradeAmountEdit: function(){
      if(this.editInput.type === "sell"){
        return this.editInput.tradeAmount = - parseInt(this.editInput.amount)
      }else {
        return this.editInput.tradeAmount = parseInt(this.editInput.amount)
      }
    },
  
  },
  mounted () {
    this.loadData();
    window.addEventListener("resize", this.myEventHandler);
    //window.addEventListener("resize", this.resizeIpPlots());
    

    
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
    //window.removeEventListener("resize", this.resizeIpPlots);
    
  },
  methods: {
    loadData: async function() {
      try{
        this.portfolio = this.get_PD_userData['depot']
        this.dividends = this.get_PD_userData['dividends']
        this.calculateTotalPortfolio();
        this.getNews();
      }
      catch{
        this.isPortfolioEmpty = true
      }
      this.isLoaded = true;
      this.showSpinner = false;
      this.updateHeight();
      //this.kpis = await this.accessEndpoint('componentAnalysis/?portfolio_id=' + this.portfolio_id +'&format=json');
      //console.log(this.kpis)
      //this.isLoaded = true;
      //this.showSpinner = false;
    },
    async getNews(){
      try{
        this.showSpinnerModal = true;
        await this.verifyToken();
        
        this.news = await this.accessEndpoint('portfolioNews/?portfolio_id=' + this.portfolio_id +'&format=json')
        this.showSpinnerModal = false;
      }catch{
        this.showSpinnerModal = false;
        this.news = []
       
      }

    },
    updateHeight: function(){
      var portfolioDivHeight = document.getElementById("portfolio-dashboard-div").offsetHeight;
      document.getElementById("grid-table-body").style.height = "calc(" + portfolioDivHeight + "px - 12.5rem)";
      document.getElementById("watch-grid-table-body").style.height = "calc(" + portfolioDivHeight + "px - 9.5rem)";
      //console.log(portfolioDivHeight)
    },
    async openSparplanModal(){
      this.isSparplanModalVisible = true;
      try{
        await this.verifyToken();
        this.sparplan = await this.accessEndpoint('showSavingPlans/?portfolio_id=' + this.portfolio_id +'&format=json')
      }catch{
        this.sparplan = []
      }
      this.input.sparplan_amount = 0;
      this.sparplanModal.overview = true;

    },
    openSparplanOverview(){
      this.sparplanModal.add = false;
      this.sparplanModal.overview = true;
    },
    openSparplanForm(){
      this.isInputValid.purchasePrice = true;
      this.sparplanModal.add = true;
      this.sparplanModal.overview = false;
    },
    addSparplan: async function(){
      this.isInputValid.purchasePrice = true;
      this.showButtonSpinner = true;
      try{
        let payload = {
          "portfolio_id": this.portfolio_id,
          "isin": this.input.isin,
          "frequency": this.input.interval,
          "starting_date": this.input.tradeDate,
          "trade_amount_eur": this.input.sparplan_amount
        }
        if(this.input.sparplan_amount > 0){
          await this.verifyToken();
          let response = await this.putEndpoint(payload, 'addSavingPlan/')
          console.log(response)
          this.sparplan = await this.accessEndpoint('showSavingPlans/?portfolio_id=' + this.portfolio_id +'&format=json')
          await this.updateData()
          this.showSuccessfulTrade('sparplanAdd')
        }else{
          this.isInputValid.purchasePrice = false;
          this.showErrorNotification = true;
        }
      }
      catch{
        this.showErrorNotification = true;
      }
      this.showButtonSpinner = false;
    },
    async deleteSparplan(sparplanId){
      this.sparplanModal.overview = false;
      try{
        let payload = {
          "portfolio_id": this.portfolio_id,
          "id": sparplanId
        }
        await this.verifyToken();
        let response = await this.deleteEndpoint('deleteSavingPlan/', payload)
        console.log(response)
        this.sparplan = await this.accessEndpoint('showSavingPlans/?portfolio_id=' + this.portfolio_id +'&format=json')
        this.showSuccessfulTrade('sparplanDel')
      }catch{
        this.showErrorNotification = true;
      }
      this.sparplanModal.overview = true;

    },
    updateHeightLarge: function(){
      var portfolioDivHeight = document.getElementById("portfolio-dashboard-div").offsetHeight;
      document.getElementById("grid-table-body").style.height = "calc(" + portfolioDivHeight + "px - 15rem)";
      //console.log(portfolioDivHeight)
    },
    updateData: async function(){
      await this.$store.dispatch('update_PD_userData', this.portfolio_id)
      this.portfolio = this.get_PD_userData['depot']
      this.dividends = this.get_PD_userData['dividends']
      try{
        this.setAssetDividendSum(this.assetModalIndex)
        this.calculateTotalPortfolio()
      }catch(e){
        console.log(e)
      }

    },
    myEventHandler() {
      this.updateHeight();
    },
    fillModalInput: function(){
      this.modalInput = {
        trade_type: "",
        trade_id: 0,
        name: "",
        isin: "",
        trade_date: new Date().toISOString().split('T')[0],
        trade_amount: 0,
        purchaseValue: 0,
        current_price: 0,
        tradeAmount: 0,
        currentPrice: 0
        }
    },
    routeToAsset: function(watchlistIndex){
      let assetIsin = this.get_PD_userData['watchlist'][watchlistIndex].isin
      this.$router.push(`/assetDetail/${assetIsin}`)
    },
    setInvestmentplanerState: function(state){
      if(state === "random"){
        this.isInvestmentplanerOpen.isClicked = true;
        this.isInvestmentplanerOpen.isRandomOpen = true;
        this.isVolaCalculated = false;
      }else if(state === "choice"){
        this.isInvestmentplanerOpen.isClicked = true;
        this.isWatchlistDataComplete = false;
        this.isInvestmentplanerOpen.isChoiceOpen = true;
        this.isVolaCalculated = false;
      }else {
        this.isInvestmentplanerOpen.isClicked = false;
        this.isInvestmentplanerOpen.isRandomOpen = false;
        this.isInvestmentplanerOpen.isChoiceOpen = false;
        this.isWatchlistDataComplete = false;
      }
      for (var key in this.stockRecommendation) {
        this.stockRecommendation[key] = '';
      }
      Plotly.purge('chart-changes')
    },
    calculateTotalPortfolio: function(){
      var pV= 0;  
      var cV = 0;
      this.portfolio.forEach(position => {
      pV += position.latest_value;
      cV += position.total_purchase_value;
      });
      
      this.totalPortfolio.total_purchase_value = Math.round(cV*100)/100;
      this.totalPortfolio.latest_value = Math.round(pV*100)/100;
      //totalPortfolio.totalReturn = Math.round((cV / pV - 1) * 10000) /100;
    },
    calculateNewWeights: async function(method){
      this.showButtonSpinner = true;
      if(method == 'random'){
        this.stockRecommendation.isin = this.recommendations[this.active-1].isin
        this.stockRecommendation.price = this.recommendations[this.active-1].security_price
      }
      let simTrade = {
        "isin": this.stockRecommendation.isin,
        "trade_amount": Math.round(parseInt(this.stockRecommendation.amount)*100)/100,
        "trade_type": "buy",
        "trade_price": this.stockRecommendation.price,
        "portfolio_id": parseInt(this.portfolio_id)
      }
      try{
        await this.verifyToken();
        let response = await this.postEndpoint(simTrade, 'simulateTrade/')
        this.newWeights = response.diversification;
        this.currentVola = response.current_volatility;
        this.simulatedVola = response.simulated_volatility;
        console.log("response simulated vola", )
        this.ipVolaTrend = response.vola_difference;
        this.isVolaCalculated = true;
        console.log(this.newWeights)
        this.updateChangePlots('security');
      }catch{
        this.showErrorNotification()
      }
      this.showButtonSpinner = false;

    },
    openCloseWatchlistModal(dataInput=[]){
      this.isWatchlistModalOpen = !this.isWatchlistModalOpen;
      if(dataInput.isin){
        this.input.isin = dataInput.isin;
        this.input.name = dataInput.name;
        this.input.purchasePrice = dataInput.security_price;
      }
    },
    
    openAsset(index){
      this.assetModalIndex = index;
      this.isAssetModalVisible = true;
      
      this.setAssetDividendSum(this.assetModalIndex)
      setTimeout(() => this.plotBasicTimeSeries('chart-trade-data'), 500)
      
      
    },
    setAssetDividendSum(assetIndex){
      let assetIsin = this.portfolio[assetIndex].isin;
      this.assetDividendSum = 0;
      this.assetDividends = []
      if(this.dividends[assetIsin] != undefined)
        this.assetDividends = this.dividends[assetIsin]
        this.assetDividends.forEach(dividend => 
          this.assetDividendSum += (dividend.total_amount - dividend.total_tax_amount)
          )
    },
    closeAsset(){
      this.isAssetModalVisible = false;
      this.assetModalIndex = 0;
    },
    openDividendModal(index){
      if(index != 999){
        this.addOrSellInput.push(Vue.util.extend({}, this.portfolio[index]));
        this.input.name = this.addOrSellInput[0].name;
        this.input.isin = this.addOrSellInput[0].isin;
        this.input.total_tax_amount = 0
        this.addOrSellInput.splice(0, 1);
      }
      this.isDividendModalOpen = true;
    },
    closeDividendModal(){
      this.isDividendModalOpen = false;
      for (var key in this.input) {
        this.input[key] = '';
      }
      this.input.tradeDate = this.dateToday
    },
    addDividend: async function(){
      this.validateDividendInput()
      for (var keyCheck in this.isDividendInputValid) {
        if(this.isDividendInputValid[keyCheck] == false){
          return "wrong amount"
        }
      }
      this.resetCheckTradeForms('dividend')
      try{
        this.showButtonSpinner = true;
        await this.verifyToken()
        let payload = {
          "portfolio_id": this.portfolio_id,
          "security_isin": this.input.isin,
          "dividend_date": this.input.tradeDate,
          "total_amount": parseInt(this.input.total_amount*100)/100,
          "total_tax_amount": parseInt(this.input.total_tax_amount*100)/100,
        }
        await this.postEndpoint(payload, 'addDividend/');
        await this.updateData();
        this.closeDividendModal();
        this.showSuccessfulTrade('dividend')
        this.showButtonSpinner = false;
      }catch{
        this.showButtonSpinner = false;
        this.showErrorNotification()
      }
    },
    editDividend: async function(){

    },
    deleteDividend: async function(dividend_id){
      try{
        let payload = {
          "dividend_id": dividend_id
        }
        this.showButtonSpinner = true;
        await this.verifyToken()
        await this.deleteEndpoint('deleteDividend/', payload);
        await this.updateData();
        this.showSuccessfulTrade('dividendDeleted')
        this.showButtonSpinner = false;
      }catch{
        this.showButtonSpinner = false;
        this.showErrorNotification()
      }
    },
    validateDividendInput(){
      if (this.input.name == ""){
        this.isDividendInputValid.name = false;
      }else{
        this.isDividendInputValid.name = true;
        if (this.checkNameIsinMatches(this.input.name, this.input.isin)){
          this.isDividendInputValid.name_isin_matches = true;
        }else {
          this.isDividendInputValid.name_isin_matches = false;
        }
      }
      if (this.input.isin == ""){
        this.isDividendInputValid.isin = false;
      }else{
        this.isDividendInputValid.isin = true;
      }
      if(isNaN(parseFloat(this.input.total_amount)) || parseFloat(this.input.total_amount) <= 0){
        this.isDividendInputValid.total_amount = false;
      }else{
        this.isDividendInputValid.total_amount = true;
      }
      if(isNaN(parseFloat(this.input.total_tax_amount)) || parseFloat(this.input.total_tax_amount) < 0){
        this.isDividendInputValid.total_tax_amount = false;
      }else{
        this.isDividendInputValid.total_tax_amount = true;
      }
      if (this.dateToday < this.input.tradeDate && this.input.tradeDate >= '2020-01-01'){
        this.isDividendInputValid.trade_date = false;
      }else{
        if(this.input.tradeDate==""){
          this.isDividendInputValid.trade_date = false;
        }else{
          this.isDividendInputValid.trade_date = true;
        }
      }

    },
    async executeClick(searchName){
      var findSecurity;
      this.showResultsName = false;
      findSecurity = this.portfolio.find(x => x.isin === searchName); 

          this.input.name = findSecurity.name;
          this.input.isin = findSecurity.isin;
        try{
          this.priceSeries = await this.accessEndpoint('securityPriceHistory/?isin=' + this.input.isin +'&format=json');
          if (this.input.tradeDate === this.dateToday){
            this.setSecurityPrice();
          }
        }
        catch{
          this.showErrorNotification()
        }
    },
    useLastListName: async function(){
      var filteredList;
        filteredList = this.portfolio.filter(security => {
          return security.name.toLowerCase().includes(this.input.name.toLowerCase())
        }) 
          this.input.name = filteredList[0].name;
          this.input.isin = filteredList[0].isin;
          this.priceSeries = null;

      
    },
    getCurrentPrice(){
      if (this.priceSeries != null){
        console.log("Preis wurde erfolgreich angepasst")
        this.setSecurityPrice();
        
      } else{
        console.log("Preise konnten nicht geladen werden")
      }
    },
    setSecurityPrice(type = 'addTrade'){
      var idxPrice;
      var lastDate;

      lastDate = this.priceSeries["dates"][this.priceSeries["dates"].length - 1]

      if(type != 'addTrade'){
        this.stockRecommendation.price = this.priceSeries["prices"][this.priceSeries["prices"].length - 1]
        this.isWatchlistDataComplete = true
      }
      else{
        if(lastDate >= this.input.tradeDate){
          idxPrice = this.priceSeries["dates"].findIndex(date =>
            date === this.input.tradeDate
          );
          if(idxPrice == -1){
            idxPrice = 0;
            //this.input.tradeDate = this.priceSeries["dates"][0];
          }
          this.input.purchasePrice = this.priceSeries["prices"][idxPrice]
        }
        else{
          this.input.purchasePrice = this.priceSeries["prices"][this.priceSeries["prices"].length - 1]
        }
      } 
    },
    ...mapActions(['load_PD_userData', 'load_SC_searchData']),
    showSuccessfulTrade: function(type){
      if(type == 'buyOrSell'){
        setTimeout(() => this.isTradeSubSuccessful = true, 200)
        setTimeout(() => this.isTradeSubSuccessful = false, 3000)
      }
      else if(type == 'edit'){
        setTimeout(() => this.isTradeEditSuccessful = true, 200)
        setTimeout(() => this.isTradeEditSuccessful = false, 3000)
      }
      else if(type == 'delete'){
        setTimeout(() => this.isTradeDelSuccessful = true, 200)
        setTimeout(() => this.isTradeDelSuccessful = false, 3000)
      }
      else if(type =='dividend'){
        setTimeout(() => this.isDividendSubSuccessful = true, 200)
        setTimeout(() => this.isDividendSubSuccessful = false, 3000)
      }
      else if(type =='dividendDeleted'){
        setTimeout(() => this.isDividendDelSuccessful = true, 200)
        setTimeout(() => this.isDividendDelSuccessful = false, 3000)
      }
      else if(type =='sparplanAdd'){
        setTimeout(() => this.isSparplanSubSuccessful = true, 200)
        setTimeout(() => this.isSparplanSubSuccessful = false, 3000)
      }
      else if(type =='sparplanDel'){
        setTimeout(() => this.isSparplanDelSuccessful = true, 200)
        setTimeout(() => this.isSparplanDelSuccessful = false, 3000)
      }

    },
    checkNameIsinMatches: function(name, isin){
      console.log(name,isin)
      let searchLen = this.searchResults.length
      if(this.tradeFromAssetMask){
        return true
      }
      if(this.isDividendModalOpen){
        let filteredList = this.portfolio.filter(security => {
          if(name.toLowerCase() == security.name.toLowerCase() && isin.toLowerCase() == security.isin.toLowerCase()){
            return true
          }
        })
        if(filteredList.length == 1){
          return true
        }
        return false
      }
      let filteredList = this.searchResults.filter(security => {
        if(searchLen == 1){
          if (name === this.searchResults[0].name){
            this.input.isin = this.searchResults[0].isin
            return true
          } else {
            return false
          }
        }
        if((security.isin.toLowerCase() == isin.toLowerCase()) && (security.name.toLowerCase() == name.toLowerCase()) == true){
          console.log((security.isin.toLowerCase() == isin.toLowerCase()) && (security.name.toLowerCase() == name.toLowerCase()))
          return true
        }
      }) 
      if(filteredList.length == 1){
        return true
      }
      return false

    },

    checkTradeForms: function(whichForm){
      if(whichForm == 'buyOrSellTrade'){
        if ((isNaN(parseFloat(this.input.amount)) || parseFloat(this.input.amount) <= 0)){
          this.isInputValid.amount = false;
        }else{
          this.isInputValid.amount = true;
          this.input.amount = this.removeSpaces(this.input.amount);
          if (typeof this.portfolio !== 'undefined')
          {
            var findSecurity = this.portfolio.find(x => x.isin === this.input.isin);
            
            if(this.input.type == 'sell' && (findSecurity.total_amount < this.input.amount)){
              this.isInputValid.sellAmount = false;
            }else{
              this.isInputValid.sellAmount = true;
            }

          }
          else{
            if(this.input.type == 'sell'){
              this.isInputValid.sellAmount = true;
            }
          }

          
        }
        if (isNaN(parseFloat(this.input.purchasePrice)) || parseFloat(this.input.purchasePrice) <= 0){
          this.isInputValid.purchasePrice = false;
        }else{
          this.input.purchasePrice = this.removeSpaces(this.input.purchasePrice);
          this.isInputValid.purchasePrice = true;
        }
        if (this.dateToday < this.input.tradeDate && this.input.tradeDate >= '2020-01-01'){
          this.isInputValid.tradeDate = false;
        }else{
          if(this.input.tradeDate==""){
            this.isInputValid.tradeDate = false;
          }else{
            this.isInputValid.tradeDate = true;
          }
        }
        if(this.input.tradeDate < '2000-01-01'){
          this.isInputValid.tradeDateMin = false;
        }else{
          this.isInputValid.tradeDateMin = true;
        }
        if (this.input.type == ""){
          this.isInputValid.type = false;
        }else{
          this.isInputValid.type = true;
        }
        if (this.input.name == ""){
          this.isInputValid.name = false;
        }else{
          this.isInputValid.name = true;
          if (this.checkNameIsinMatches(this.input.name, this.input.isin) == true){
            this.isInputValid.nameIsinMatches = true;
          }else {
            this.isInputValid.nameIsinMatches = false;
          }
        }
        if (this.input.isin == ""){
          this.isInputValid.isin = false;
        }else{
          this.isInputValid.isin = true;
        }
        
      }
      else if(whichForm == 'edit'){
       
        if (isNaN(parseFloat(this.editInput.trade_amount)) || parseFloat(this.editInput.trade_amount) <= 0){
          this.isEditInputValid.amount = false;
        }else{
          this.editInput.trade_amount = this.removeSpaces(this.editInput.trade_amount);
          this.isEditInputValid.amount = true;
        }

        if (isNaN(parseFloat(this.editInput.trade_price)) || parseFloat(this.editInput.trade_price) <= 0){
          this.isEditInputValid.purchasePrice = false;
        }else{
          this.editInput.trade_price = this.removeSpaces(this.editInput.trade_price);
          this.isEditInputValid.purchasePrice = true;
        }

        if (this.dateToday < this.editInput.trade_date){
          this.isEditInputValid.tradeDate = false;
        }else{
          if(this.editInput.trade_date==""){
            this.isEditInputValid.tradeDate = false;
          }else{
            this.isEditInputValid.tradeDate = true;
          }
        }

        if (this.editInput.trade_type == ""){
          this.isEditInputValid.type = false;
        }else{
          this.isEditInputValid.type = true;
        }
        
      }
    },
    removeSpaces: function(string){
      if(isNaN(string)){
        string = string.split(" ").join("")
      }
      return string
    },
    resetCheckTradeForms: function(whichForm){
      if(whichForm == 'buyOrSellTrade'){
        for(var keyForm in this.isInputValid){
          this.isInputValid[keyForm] = true;
        }
      }
      else if(whichForm == 'edit'){
        for(var keyFormEdit in this.isEditInputValid){
          this.isEditInputValid[keyFormEdit] = true;
        }
      }
      else{
        for(var keyFormDividend in this.isDividendInputValid){
          this.isDividendInputValid[keyFormDividend] = true;
        }  
      }
    },


  async retrieveRecommendations(){
      var recData;
      this.showButtonSpinnerNew = true;
      try{
        recData = await this.accessEndpoint('randomSecurities/?format=json');
        var counter;
        var security;
        this.recommendations = [];
        var keys = ["isin", "name", "sector", "security_type", "region", "security_price", "model_result"]
        for (var i = 0; i < recData.length; i++) {
            var searchResults = recData[i];
            security = []
            for (counter in keys) {
                var value = searchResults[keys[counter]];
                security.push(value);
            }
            this.recommendations.push(new Recommendation(security[0],security[1],security[2],security[3],security[4],security[5],security[6]));
          }
      }catch{
        this.showErrorNotification();
      }
      this.showButtonSpinnerNew = false;

  },

  
  async showSecurityModal() {
    try{
      this.verifyToken();
      this.showSpinnerModal = true;
      await this.retrieveRecommendations();
      this.showSpinnerModal = false;
      this.isSecurityModalVisible = true;
      
      setTimeout(() => this.updateChangePlots('security'), 1000)
      this.buttonActivation("nav-bar-changes", "btn");

    }catch{
      this.showSpinnerModal = false;
      this.showErrorNotification()
    }

  },
  resizeIpPlots(){
    //var activeTab;
    //activeTab = this.getActiveTab("nav-bar-changes");
    if(this.isSecurityModalVisible == true){
      this.updateChangePlots('security')
    }
    

    
    
  },
  closeSecurityModal() {
    this.isSecurityModalVisible = false;
    this.setInvestmentplanerState('close');
    this.isVolaCalculated = false;
  },
  closeSecurityModalAndSubmit(){
    this.isSecurityModalVisible = false;
  },
  closeModal() {
    this.isModalVisible = false;
    this.isBuyOrSellModalVisible = false;
    this.isModalDeleteVisible = false;
    this.isSparplanModalVisible = false;
    this.sparplanModal.add = false;
    this.sparplanModal.overview = false;
    this.input.name = "";
    this.input.isin = "";
    this.input.type = "";
    this.input.amount = 0;
    this.input.purchasePrice = 0;
    this.resetCheckTradeForms('buyOrSellTrade');
  },
  

  changePerformanceDetails: function(){
    this.showPerformanceDetails = !this.showPerformanceDetails
    if(this.showPerformanceDetails == true){
      this.updateHeightLarge()
    }else{
      this.updateHeight()
    }
  },

  updateChangePlots: function(key){
    var requestedDiversificationData = this.get_PD_userData['diversification'][key];
    this.plotPieChart(requestedDiversificationData, "chart-current");
    if(this.newWeights){
      this.plotPieChart(this.newWeights[key], "chart-changes");
    }


  },
  move(amount) {
    let newActive
    const newIndex = this.active + amount
    if (newIndex > this.slides) newActive = 1
    if (newIndex === 0) newActive = this.slides
    this.active = newActive || newIndex
    this.isVolaCalculated = false;
    Plotly.purge('chart-changes')
  },
  jump(index) {
    this.active = index
    this.isVolaCalculated = false;
    Plotly.purge('chart-changes')
  },
  showWatchlistColumns: function(){
      this.isWatchlistColumnVisible = !this.isWatchlistColumnVisible
  },
  addToWatchlist: async function(postInput) {
    var data;
    data = {
      "portfolio_id": this.portfolio_id,
      "isin": postInput.isin,
      "watch_date": new Date().toISOString().split('T')[0],
      "watch_price": postInput.purchasePrice

  } 

  try{
    
    this.showButtonSpinner = true;
    await this.postEndpoint(data, 'addWatch/');
    this.showButtonSpinner = false;
    this.openCloseWatchlistModal()
    this.showSuccessfulTrade('buyOrSell')
    for (var key in this.input) {
      this.input[key] = '';
    }
    await setTimeout(() => this.updateData(), 1000)

  }catch{
    this.showButtonSpinner = false;
    this.showErrorNotification()
  }
},



    //function to add data to table
    add: async function() {

      this.checkTradeForms('buyOrSellTrade');
      for (var keyCheck in this.isInputValid) {
        if(this.isInputValid[keyCheck] == false){
          return "wrong amount"
        }
      }
      try{
        this.isLoaded = false;
        this.showButtonSpinner = true;
        await this.verifyToken();
        this.resetCheckTradeForms('buyOrSellTrade');
        var data;
        data = {
          "portfolio_id": this.portfolio_id,
          "trade_type": this.input.type,
          "security_isin": this.input.isin,
          "trade_date": this.input.tradeDate,
          "trade_amount": parseInt(this.input.amount*100)/100,
          "trade_price": parseInt(this.input.purchasePrice*100)/100,

        }
        console.log("data:", data)
        await this.postEndpoint(data, 'addTrade/');
        await this.updateData()
        this.closeModal();

        for (var key in this.input) {
          this.input[key] = '';
        }

        this.isPortfolioEmpty = false;
        this.isLoaded = true;
        this.showButtonSpinner = false;
        this.showSuccessfulTrade('buyOrSell');
        
      }catch{
        this.showButtonSpinner = false;
        this.showErrorNotification()
        try{
          await this.updateData()
        }catch{
          print("cannot access endpoint")
        }
        
      }
      this.updateHeight();
    },
    //function to handle data edition
    edit: function(index, tradeIndex) {
      //this.editInput = this.portfolio[index]['trades'][tradeIndex];
      this.editInput = [];
      this.editInput.push(Vue.util.extend({}, this.portfolio[index]['trades'][tradeIndex]))
      this.editInput = this.editInput[0]; 
      this.editInput.isin = this.portfolio[index].isin
      this.editInput.name = this.portfolio[index].name
      this.isModalVisible = true;
      },

    deleteTrade: function(index, tradeIndex) {
      this.editInput.push(Vue.util.extend({}, this.portfolio[index]['trades'][tradeIndex]))
      this.editInput = this.editInput[0]; 
      this.editInput.isin = this.portfolio[index].isin;
      this.editInput.name = this.portfolio[index].name;
      this.isModalDeleteVisible = true;
    },
    deleteWatchlistTrade: function(watchlistIndex){
      
      this.editInput.push(Vue.util.extend({}, this.get_PD_userData['watchlist'][watchlistIndex]))
      this.editInput = this.editInput[0]
      this.isModalDeleteVisible = true;
    },

    buyOrSell: async function(index, tradetype) {
      if( tradetype == 'buy' || tradetype == 'sell'){
        this.tradeFromAssetMask = true;
        this.addOrSellInput.push(Vue.util.extend({}, this.portfolio[index]));
        this.input.type = tradetype;
        this.input.name = this.addOrSellInput[0].name;
        this.input.isin = this.addOrSellInput[0].isin;
        this.input.modelAssessment = this.addOrSellInput[0].model_result;
        this.input.currentPrice = this.addOrSellInput[0].latest_price;
        this.input.tradeDate = this.dateToday;
        this.addOrSellInput.splice(0, 1);
        this.priceSeries = [];
        try{
          this.priceSeries = await this.accessEndpoint('securityPriceHistory/?isin=' + this.input.isin +'&format=json');
          this.setSecurityPrice();
        }catch{
          console.log('could not retrieve latest stock price data')
          this.showErrorNotification()
        }


      }  else {
        this.tradeFromAssetMask = false;
        this.input.type = 'buy';
        this.input.tradeDate = new Date().toISOString().split('T')[0]
        if(tradetype == 'watch'){
          this.input.type = tradetype;
        }
        }
      this.isBuyOrSellModalVisible = true;
    },

    changeTradesVisible: function(index){
      this.portfolio[index].isTradeVisible = !this.portfolio[index].isTradeVisible;
    },

    update: async function(input){
      
      if (input === true) {
        this.checkTradeForms('edit');
        for (var keyCheck in this.isEditInputValid) {
          if(this.isEditInputValid[keyCheck] == false){
            return "wrong amount"
          }
        }
        this.resetCheckTradeForms('buyOrSellTrade');
        var data;
        var updateUrl;
        data = {
          "trade_id": this.editInput.trade_id,
          "trade_type": this.editInput.trade_type,
          "portfolio_id": this.portfolio_id,
          "security_isin": this.editInput.isin,
          "trade_price": parseInt(this.editInput.trade_price*100)/100,
          "trade_date": this.editInput.trade_date,
          "trade_amount": parseInt(this.editInput.trade_amount*100)/100
        }
        updateUrl = 'editTrade/';
        try{
          this.showButtonSpinner = true;
          await this.verifyToken();
          await this.putEndpoint(data, updateUrl);
          await this.updateData();
          this.showButtonSpinner = false;
          this.showSuccessfulTrade('edit');
        }catch{
          this.showButtonSpinner = false;
        this.showErrorNotification();
      }
       
      }
      this.editInput = [];
       
      this.closeModal();
    },
    //function to defintely delete data 
    deplete: async function() {
      var updateUrl;
      if(this.editInput.watch_price){
        updateUrl = 'deleteWatch/?watch_id=' + parseInt(this.editInput.watch_id);
      }else{
        updateUrl = 'deleteTrade/?trade_id=' + parseInt(this.editInput.trade_id);
      }
      try{
        this.showButtonSpinner = true;
        
        await this.verifyToken();
        await this.deleteEndpoint(updateUrl, this.editInput);
        this.editInput = []
        this.isAssetModalVisible = false;
        this.closeModal();
        await this.updateData();
        
        this.showButtonSpinner = false;
        this.showSuccessfulTrade('delete');
      }catch{
        this.showButtonSpinner = false;
        this.showErrorNotification();
      }

    },


    async search(input) {
      let currentTime = new Date().toLocaleString().replace(',','')
      let msDifference =  currentTime - this.startTime;
      let minutes = Math.floor(msDifference/1000/60);
      if(minutes > 10){
        await this.verifyToken()
        this.startTime = currentTime
      }
      return new Promise((resolve, reject) => {
        if (input.length < 3) {
          return resolve([])
        }
        if(this.isInvestmentplanerOpen.isChoiceOpen == true){
          this.stockRecommendation.name = input
        }else{
          this.input.name = input;
        }
        
        axios.post(domain + 'searchResults/?format=json', {"search": input},{
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('access-token')
                  }
          }).then(
              (response) => { 
                  var result = response.data;
                  console.log("results:", result)
                  this.searchResults = result
                  if(result.length > 0){
                    resolve(result); 
                  }else{
                    let noResults = {
                      name: 'Keine Suchergebnisse',
                      isin: ''
                    }
                    resolve([noResults])
                  }
                  
              }, 
                  (error) => {
                    this.$router.go(0)  
                    reject(error); 
              } 
          ); 
      }); 
    },
    setInput(result){
      this.input.name = result.name;
      this.input.isin = result.isin;
    },
    getResultValue(result) {
      return result.name
    },
    routeAssetDetail(isin){
      if(isin.length > 0){
        //let routeData = this.$router.resolve({name: "/assetDetail/" + isin, href: "https://www.sigmafol.io/"});
        //console.log(routeData)
        //window.open(routeData.href, '_blank');
        let routing = this.$router.currentRoute.name
        this.$router.push("/assetDetail/" + isin);

        if(routing.includes('assetDetail')){
          this.$router.go(0)
        }

      }
    },
    async handleSubmit(result) {

      try{
        this.priceSeries = await this.accessEndpoint('securityPriceHistory/?isin=' + result.isin +'&format=json');
      }catch{
        console.log("cannot retrieve price series for isin:", result.isin)
      }
      
      if(this.isInvestmentplanerOpen.isChoiceOpen == true){
        this.stockRecommendation.name = result.name
        this.stockRecommendation.isin = result.isin
        this.setSecurityPrice('investmentplanner');
      }else{
        this.input.name = result.name
        this.input.isin = result.isin
        this.setSecurityPrice();
      }
    }
}
}




